import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

export interface SectionHeadingProps {
	children: ReactNode
	className?: string
}

function SectionHeading({ children, className }: SectionHeadingProps) {
	return (
		<h3 className={cn('py-4 text-lg leading-7 font-[500] text-(--color-foreground)', className)}>
			{children}
		</h3>
	)
}

SectionHeading.displayName = 'SectionHeading'

export { SectionHeading }
